import Joi from 'joi';

import { requiredEmail } from '../../utils/validators';
import { FormValues } from './types';

export const validationSchema = Joi.object<FormValues, true>({
  emailId: requiredEmail,
  marketing: Joi.boolean(),
});
